<template>
  <div class="group-statistic">
    <div :class="['slider', { 'slider-active': showResults }]">
      <test-table
        :groupData="componentData"
        :error="textError"
        :stats="stats"
        @change="changeWindow"
      />
      <viewing-result
        ref="viewingResult"
        @change="changeWindow"
        :group="selectedGroup"
        :test="componentData"
      />
    </div>
  </div>
</template>

<script>
import testTable from "./groupStatistic/table";
import viewingResult from "./groupStatistic/viewingResult";
export default {
  data() {
    return {
      selectedGroup: {},
      stats: [],
      showResults: false,
      textError: "",
    };
  },
  props: {
    componentData: Object,
  },
  components: {
    "test-table": testTable,
    "viewing-result": viewingResult,
  },
  methods: {
    changeWindow(value) {
      this.selectedGroup = value;
      this.showResults =
        Object.keys(value).length !== 0 && value.constructor === Object
          ? true
          : false;
      if (Object.keys(value).length !== 0 && value.constructor === Object) {
        this.$refs.viewingResult.fethHistories(value);
      }
    },
  },
  mounted() {
    this.axios
      .get(
        `api/tresults/${this.componentData.test_id}/group/${this.componentData.group_id}/histories`
      )
      .then((res) => {
        this.stats = res.data.stats;
      })
      .catch((error) => {
        this.textError =
          "Не верно сформирован тест. Не указан правильный ответ.";
      });
  },
};
</script>

<style lang="scss">
.group-statistic {
  height: 90%;
  .slider {
    height: 100%;
    overflow-x: hidden;
    height: 100%;
    display: flex;
    justify-content: space-between;
    position: relative;
    perspective: 1000px;
  }
  .slider-active .table-container,
  .slider-active.flip .table-container {
    transform: rotateX(180deg);
  }
  .slider-active .viewing-result,
  .slider-active.flip .viewing-result {
    transform: rotateX(0deg);
  }
  .slider .viewing-result {
    transform: rotateY(-180deg);
  }
  .slider-active .table-container,
  .slider.flip .table-container {
    transform: rotateY(180deg);
  }
  .slider-active .viewing-result,
  .slider.flip .viewing-result {
    transform: rotateY(0deg);
  }
  .slider .viewing-result {
    //transform: rotateY(-180deg);
  }
}
</style>